module.exports = __webpack_public_path__ + "static/img/concierge_resident.485df88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/concierge_resident.png
// module id = IP8o
// module chunks = 1